import React, { useEffect, useState } from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { toReadableDateTime } from "../../../../utils/DateHelpers";

const Card = styled.div`
    background-color: ${({ theme }) => theme.colors.red.toString()};
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    color: ${({ theme }) => theme.colors.white.toString()};
    justify-content: center;
    align-items: center;
    width: 140px;
    padding: 5px;
    text-align: center;
    ${({ theme }) => css`
        ${theme.breakpoints.from.small.css`
          width: 170px;
      `}
    `}
`;

const Headline = styled.h5`
    font-size: 1rem;
`;

const Price = styled.h5`
    display: flex;
    font-size: 1.5rem;
    font-weight: 600;
`;

const StyledSpan = styled.span`
    align-self: flex-start;
    font-size: 1rem;
`;

const Disclaimer = styled.span`
    font-size: 10px;
`;

const PriceCard = ({ item }) => {
    const [price, setPrice] = useState("");
    const [smallNumber, setSmallNumber] = useState("");
    const [decimalDigit, setDecimalDigit] = useState("");
    useEffect(() => {
        let newPrice = item.preis.toFixed(3);
        newPrice = newPrice.toString().includes(".")
            ? newPrice.toString().split(".")
            : newPrice.toString();
        if (newPrice.constructor === Array) {
            if (newPrice !== "" && newPrice[1].length === 3) {
                setDecimalDigit(newPrice[1].slice(0, -1));
                setSmallNumber(newPrice[1].slice(2));
            } else {
                setDecimalDigit(newPrice[1]);
            }
            setPrice(newPrice[0]);
        } else {
            setPrice(newPrice);
        }
    }, [item]);

    return (
        <Card>
            <Headline>{item.kraftstoffe_name}</Headline>
            <Price>
                {price}
                {decimalDigit && (
                    <>
                        .<span>{decimalDigit}</span>
                    </>
                )}
                {smallNumber && <StyledSpan>{smallNumber}</StyledSpan>}
            </Price>
            <Disclaimer>
                {toReadableDateTime(
                    `${item.gueltig_datum} ${item.gueltig_zeit}`,
                    true
                )}{" "}
                Uhr
            </Disclaimer>
        </Card>
    );
};

export default PriceCard;
